import React, {FC} from "react"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {H5} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import BoldNumberSmallText from "../BoldNumberSmallText"

interface Props extends InjectIntl {
  onClick: () => void
}

const FlexCard = styled(Card)`
  flex: 1 1 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({theme}) => theme.colors.utility.success};
`

const EmptyValues: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()
  return (
    <FlexCard>
      <Flex justifyContent="space-between">
        <Flex marginBottom={2} alignItems="center" gap={0.5}>
          <H5 color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.dashboard.reporting.valuesCelebrationsWidget.empty.title" />
          </H5>
        </Flex>
      </Flex>
      <Flex justifyContent="center" marginBottom={1}>
        <img width="100px" src={formatMessage({id: "admin.components.dashboard.reporting.valuesCelebrationsWidget.img"})} />
      </Flex>
      <BoldNumberSmallText
        boldValue={formatMessage({id: "admin.components.dashboard.reporting.valuesCelebrationsWidget.empty.bold"})}
        text="admin.components.dashboard.reporting.valuesCelebrationsWidget.empty.text"
        color={theme.colors.greys.white}
      />
      <Flex justifyContent="flex-end" marginTop={1}>
        <ButtonRouterLink inverted to="/settings/customisation/values">
          <FormattedMessage id="admin.components.dashboard.reporting.valuesCelebrationsWidget.empty.button" />
        </ButtonRouterLink>
      </Flex>
    </FlexCard>
  )
}

export default injectIntl(EmptyValues)
